import React, { useEffect, useRef, useState } from 'react';
import { createNewOrder, getDeliveryTimeApi, getPickupTimeApi } from '../../redux/Reducers/CreateOrderReducer';
import { amountCheckFn, formatAndSortStartTimes, timeIdGenarate } from '../../utils/commonUtil';
import { dateFn, getTimeZoneAbbr, utcTimeToLocalTime } from '../../utils/dateTimeFormatter';
import { CalendarIcon, ClockIcon, MapPinIcon } from '@heroicons/react/24/outline';
import DropdownDateTime from '../../components/DropdownDateTime';
import cart from '../../images/shopping-cart.png';
import Loader from '../../components/Loader';
import toast from 'react-hot-toast';
import { add, isEmpty, isNull, set } from 'lodash';
import moment from 'moment';
import GroupServices from './GroupServices';
import { useDispatch, useSelector } from 'react-redux';
import Stripe from '../../components/Stripe';
import { getBillingDetailsApi } from '../../redux/Reducers/commonApis';
import { titleCaseFormatter } from '../../utils/stringFormatters';
import EditIcon from '../../components/Icons/EditIcon';
import GroupFormSummary from './GroupFormSummary';
import { setGroupOrderDetailsAction } from '../../redux/Actions/GroupActions';
import ClientButton from '../../components/ClientButton';
import Button from '../../components/Button';
import { AddressAutofill } from '@mapbox/search-js-react';
import { addNewServiceAddressesApi, updateServiceAddressesApi } from '../../redux/Reducers/ServiceAddressesReducer';
import { getProfileDataApi } from '../../redux/Reducers/ProfileReducer';
import OrderPreferencesModule from '../../components/OrderPreferencesModule';
const MAPBOX_API_TOKEN =
  import.meta.env.VITE_TENANT_NAME === 'laundrycare'
    ? import.meta.env.VITE_LAUNDRYCARE_MAPBOX_API_TOKEN
    : import.meta.env.VITE_TENANT_NAME === 'pushlaundry'
    ? import.meta.env.VITE_PUSHLAUNDRY_MAPBOX_API_TOKEN
    : '';
export default function CreateOrderGroup({ setStep }) {
  const nameField = useRef(null);
  const address1Field = useRef(null);
  const address2Field = useRef(null);
  const address3Field = useRef(null);
  const cityField = useRef(null);
  const stateField = useRef(null);
  const zipField = useRef(null);
  const dispatch = useDispatch();
  const { groupData } = useSelector((state) => state.group);
  const { profileData } = useSelector((state) => state.profile);
  const { allServiceAddresses } = useSelector((state) => state.serviceAddresses);
  const { selectedServices } = useSelector((state) => state.group);
  const [selectedTimeSlots, setSelectedTimeSlots] = React.useState({
    pickup_date: '',
    pickup_start_time: '',
    pickup_end_time: '',
    dropoff_date: '',
    dropoff_start_time: '',
    dropoff_end_time: '',
    selected_pickup_time_id: '',
    selected_dropoff_time_id: '',
    is_rush: false,
  });
  const [loading, setLoading] = React.useState(false);
  const [updateServiceAddressLoading, setUpdateServiceAddressLoading] = useState(false);
  const [editAddress, setEditAddress] = React.useState(true);
  const [addressData, setAddressData] = React.useState(null);
  const [pickupLoading, setPickupLoading] = React.useState(false);
  const [deliveryLoading, setDeliveryLoading] = React.useState(false);
  const [availablePickupSchedules, setAvailablePickupSchedules] = React.useState([]);
  const [pickupDateBlocks, setPickupDateBlocks] = React.useState([]);
  const [pickupTimeBlocks, setPickupTimeBlocks] = React.useState([]);
  const [availableDeliverySchedules, setAvailableDeliverySchedules] = React.useState({});
  const [deliveryDateBlocks, setDeliveryDateBlocks] = React.useState([]);
  const [deliveryTimeBlocks, setDeliveryTimeBlocks] = React.useState([]);
  const [showAllPickupDates, setShowAllPickupDates] = React.useState(false);
  const [showAllDropoffDates, setShowAllDropoffDates] = React.useState(false);
  const [preferences, setPreferences] = React.useState(null);
  const [tip, setTip] = React.useState('');
  const [billingDetails, setBillingDetails] = React.useState(null);
  const [editBillingDetails, setEditBillingDetails] = React.useState(true);
  const [stripeLoading, setStripeLoading] = React.useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const getBillingDetailsFn = (id) => {
    setStripeLoading(true);
    const response = getBillingDetailsApi(id);
    response.then((res) => {
      if (res?.status === 200 || res?.status === 201) {
        setEditBillingDetails(false);
        setBillingDetails(res?.data || {});
        setStripeLoading(false);
      } else {
        toast.error(res?.message || 'Something went wrong');
        setStripeLoading(false);
      }
    });
  };
  // --- Utility Functions ---
  const convertDateTimeFormatFn = (schedules) => {
    return Object.entries(schedules || {}).map(([key, value]) => ({
      date: dateFn('type4', key),
      dateWeekday: dateFn('type7', key),
      dateMonthDate: dateFn('type8', key),
      dateUnformatted: key,
      times: value?.map((item) => ({
        value: `${utcTimeToLocalTime(
          `${key}T${item?.start_time}`,
          allServiceAddresses?.[0]?.time_zone
        )} - ${utcTimeToLocalTime(`${key}T${item?.end_time}`, allServiceAddresses?.[0]?.time_zone)}`,
        start_time: utcTimeToLocalTime(`${key}T${item?.start_time}`, allServiceAddresses?.[0]?.time_zone),
        end_time: utcTimeToLocalTime(`${key}T${item?.end_time}`, allServiceAddresses?.[0]?.time_zone),
        default: {
          start_time: item?.start_time,
          end_time: item?.end_time,
        },
        dateUnformatted: key,
        time_zone: getTimeZoneAbbr(`${key}T${item?.start_time}`, allServiceAddresses?.[0]?.time_zone),
        id: timeIdGenarate(key, item?.start_time),
      })),
    }));
  };

  const onPickupDateChange = (date) => {
    if (date) {
      const pickupTimes = pickupDateBlocks?.find((item) => item?.dateUnformatted === date)?.times || [];
      setPickupTimeBlocks(pickupTimes);
    }
  };

  const getPickupTimes = async () => {
    setPickupLoading(true);
    try {
      const res = await getPickupTimeApi(null, allServiceAddresses?.[0]?.id, 'ORDER');
      if (res?.status === 200 || res?.status === 201) {
        setAvailablePickupSchedules(res?.data || []);
      } else {
        toast.error(res?.message || 'Failed to fetch pickup times');
      }
    } catch (err) {
      toast.error('Failed to fetch pickup times');
    } finally {
      setPickupLoading(false);
    }
  };

  const generatePickDataTimes = (value) => {
    const sorted = formatAndSortStartTimes(value || {}, allServiceAddresses?.[0]?.time_zone);
    const dataNew = convertDateTimeFormatFn(sorted || {});
    setPickupDateBlocks(dataNew);
    if (Object.keys(sorted).length > 0) {
      setSelectedTimeSlots((prevState) => ({
        ...prevState,
        pickup_date: Object.keys(sorted)[0],
        pickup_start_time: sorted[Object.keys(sorted)[0]][0]?.start_time,
        pickup_end_time: sorted[Object.keys(sorted)[0]][0]?.end_time,
        selected_pickup_time_id: timeIdGenarate(Object.keys(sorted)[0], sorted[Object.keys(sorted)[0]][0]?.start_time),
      }));
    }
  };

  const getDeliveryTimeFn = async (selected) => {
    setDeliveryLoading(true);
    const payload = {
      items: selectedServices.map((item) => ({
        service_id: item?.service_id,
        quantity: item?.quantity,
      })),
      pickup_date: selected?.pickup_date,
      pickup_start_time: selected?.pickup_start_time,
      type: 'ORDER',
    };
    try {
      const response = await getDeliveryTimeApi('null', allServiceAddresses?.[0]?.id, payload, 'ORDER');
      if (response?.status === 200 || response?.status === 201) {
        const dataNew = formatAndSortStartTimes(response?.data?.data || {}, allServiceAddresses?.[0]?.time_zone);
        setAvailableDeliverySchedules(dataNew);
        // Select first available slot
        let firstNonRushSlot =
          Object.entries(dataNew)
            .flatMap(([date, slots]) => slots.map((slot) => ({ date, ...slot })))
            .find((slot) => !slot.is_rush) ||
          Object.entries(dataNew)
            .flatMap(([date, slots]) => slots.map((slot) => ({ date, ...slot })))
            .find((slot) => slot.is_rush);

        if (firstNonRushSlot) {
          setSelectedTimeSlots((prevState) => ({
            ...prevState,
            selected_dropoff_time_id: timeIdGenarate(firstNonRushSlot?.date, firstNonRushSlot?.start_time),
            dropoff_start_time: firstNonRushSlot?.start_time,
            dropoff_end_time: firstNonRushSlot?.end_time,
            dropoff_date: firstNonRushSlot?.date,
          }));
        }
        if (isEmpty(dataNew)) {
          toast.error('No delivery times available for the selected pickup date and time');
          setDeliveryDateBlocks([]);
          setDeliveryTimeBlocks([]);
          setSelectedTimeSlots((prevState) => ({
            ...prevState,
            dropoff_date: null,
          }));
        }
      } else {
        toast.error(response?.message || 'Something went wrong');
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Something went wrong');
    } finally {
      setDeliveryLoading(false);
    }
  };

  const onDeliveryDateChange = (date) => {
    if (date) {
      const times = availableDeliverySchedules?.[date] || [];
      const YYMMDDDate = moment(date).format('YYYY-MM-DD');
      const deliveryTimes = times.map((time) => ({
        value: `${utcTimeToLocalTime(
          `${YYMMDDDate}T${time?.start_time}`,
          allServiceAddresses?.[0]?.time_zone
        )} - ${utcTimeToLocalTime(`${YYMMDDDate}T${time?.end_time}`, allServiceAddresses?.[0]?.time_zone)}`,
        default: {
          start_time: time?.start_time,
          end_time: time?.end_time,
        },
        priority_fee: !isNaN(time?.priority_fee) && time?.priority_fee >= 0 && amountCheckFn(time?.priority_fee),
        is_rush: time?.is_rush && time?.is_rush,
        displayValue: `${utcTimeToLocalTime(
          `${YYMMDDDate}T${time?.start_time}`,
          allServiceAddresses?.[0]?.time_zone
        )} - ${utcTimeToLocalTime(`${YYMMDDDate}T${time?.end_time}`, allServiceAddresses?.[0]?.time_zone)}`,
        id: timeIdGenarate(YYMMDDDate, time?.start_time),
      }));
      setDeliveryTimeBlocks(deliveryTimes);
    }
  };

  const generateDeliveryDates = (times) => {
    const deliveryDates = Object.keys(times).map((date) => ({
      id: dateFn('YYYYMMDD', date),
      value: dateFn('type3', date),
      dateYYYYMMDD: dateFn('YYYY-MM-DD', date),
      dateWeekday: dateFn('type7', date),
      dateMonthDate: dateFn('type8', date),
    }));
    setDeliveryDateBlocks(deliveryDates);
  };

  // --- Effects ---
  React.useEffect(() => {
    if (allServiceAddresses?.[0]?.id) getPickupTimes();
    // eslint-disable-next-line
  }, [allServiceAddresses?.[0]?.id]);

  React.useEffect(() => {
    if (availablePickupSchedules && Object.keys(availablePickupSchedules).length > 0) {
      generatePickDataTimes(availablePickupSchedules);
    }
    // eslint-disable-next-line
  }, [availablePickupSchedules]);

  React.useEffect(() => {
    if (!isEmpty(availableDeliverySchedules)) {
      generateDeliveryDates(availableDeliverySchedules);
    }
    // eslint-disable-next-line
  }, [availableDeliverySchedules]);

  React.useEffect(() => {
    if (selectedTimeSlots?.pickup_date && selectedServices?.length > 0) getDeliveryTimeFn(selectedTimeSlots);
    // eslint-disable-next-line
  }, [selectedTimeSlots?.selected_pickup_time_id, selectedServices]);

  React.useEffect(() => {
    if (availableDeliverySchedules && selectedTimeSlots?.dropoff_date) {
      onDeliveryDateChange(selectedTimeSlots?.dropoff_date);
    }
    // eslint-disable-next-line
  }, [availableDeliverySchedules, selectedTimeSlots?.dropoff_date]);

  React.useEffect(() => {
    if (pickupDateBlocks && pickupDateBlocks.length > 0) {
      onPickupDateChange(pickupDateBlocks[0]?.dateUnformatted);
    }
    // eslint-disable-next-line
  }, [pickupDateBlocks]);

  // --- Validation (basic) ---
  const isTipValid = tip === '' || /^\d+(\.\d{1,2})?$/.test(tip);
  const createOrderFn = () => {
    const payload = {
      service_address_id: allServiceAddresses?.[0]?.id,
      items: selectedServices?.map((item) => {
        return {
          service_id: item?.service_id,
          quantity: item?.quantity,
        };
      }),
      pickup_date: selectedTimeSlots?.pickup_date,
      dropoff_date: selectedTimeSlots?.dropoff_date,
      pickup_start_time: selectedTimeSlots?.pickup_start_time,
      pickup_end_time: selectedTimeSlots?.pickup_end_time,
      dropoff_start_time: selectedTimeSlots?.dropoff_start_time,
      dropoff_end_time: selectedTimeSlots?.dropoff_end_time,
      preferences: preferences || undefined,
      final_tip: tip ? parseFloat(tip) : undefined,
      create_order: true,
    };
    setLoading(true);
    const response = createNewOrder(payload, 'ORDER');
    response.then((res) => {
      if (res?.status === 200 || res?.status === 201) {
        setLoading(false);
        setStep(4);
        dispatch(
          setGroupOrderDetailsAction({
            orderId: res?.order_id,
            payload: payload,
          })
        );
        toast.success(res?.message || 'Order created successfully');
      } else {
        setLoading(false);
        toast.error(res?.message || 'Something went wrong');
      }
    });
  };
  const addressChangeFn = (data) => {
    setAddressData((prev) => ({
      ...prev,
      address_line_1: data.features[0].properties.address_line1,
      address_line_2: data.features[0].properties.address_line2,
      city: data.features[0].properties.address_level2,
      state: data.features[0].properties.address_level1,
      postal_code: data.features[0].properties.postcode,
      full_address: data.features[0].properties.full_address,
    }));
  };
  const validateAddressFn = (address) => {
    const fields = ['name', 'address_line_1', 'city', 'state', 'postal_code'];
    for (const field of fields) {
      if (!address[field] || address[field] === '') {
        toast.error(`Please enter a ${field.replace('_', ' ')}`);
        setAddressData((prev) => ({ ...prev, [field]: null }));
        return false;
      }
    }
    return true;
  };
  const onAddressSave = () => {
    const payload = {
      name: 'Home',
      address_line_1: addressData?.address_line_1,
      address_line_2: address2Field?.current?.value || '',
      city: addressData?.city,
      state: addressData?.state,
      postal_code: addressData?.postal_code,
    };
    const payloadHotel = {
      address_line_2: address3Field?.current?.value || '',
    };
    if (groupData?.group_account_type != 'HOTEL' && !validateAddressFn(payload)) {
      return;
    }
    setUpdateServiceAddressLoading(true);
    const create = dispatch(
      updateServiceAddressesApi(
        groupData?.group_account_type == 'HOTEL' ? payloadHotel : payload,
        allServiceAddresses?.[0]?.id
      )
    );
    create.then((res) => {
      if (res?.status === 200 || res?.status === 201 || res?.status === 204) {
        dispatch(getProfileDataApi());
        setUpdateServiceAddressLoading(false);
        setEditAddress(false);
        toast.success('Address updated successfully');
      } else {
        setUpdateServiceAddressLoading(false);
        toast.error(res?.message || 'Something went wrong');
      }
    });
  };
  useEffect(() => {
    setAddressData(allServiceAddresses?.[0] || {});
  }, [allServiceAddresses]);

  // --- Render ---
  return (
    <div className='bg-client-900 relative mx-auto min-h-screen w-full max-w-md space-y-6 pb-6'>
      {/* Pickup & Delivery */}
      <div
        className='absolute right-1 -top-14 cursor-pointer'
        onClick={(e) => {
          e.stopPropagation();
          setModalOpen(true);
        }}
      >
        <img src={cart} className='bg-client-300 h-10 w-10 rounded-full p-1.5' alt='cart' />
        <div className=' absolute -top-1 -right-1 flex h-5 w-5 items-center justify-center rounded-full bg-red-600 align-middle text-white'>
          <span className='text-sm'> {selectedServices.length}</span>
        </div>
      </div>
      <div className='rounded-2xl bg-white p-6 shadow'>
        <div>
          <h2 className='text-client-800 mb-4 text-base font-semibold'>Pickup & Delivery</h2>

          <hr className='mb-4' />
          {/* Address and Room Number */}
          {!editAddress ? (
            <div className='relative'>
              <div className='absolute right-1 top-1 '>
                <EditIcon
                  onClick={() => {
                    setEditAddress(true);
                  }}
                />
              </div>
              <div className='mb-1 flex'>
                <MapPinIcon className='text-client-800 h-8 w-8' aria-hidden='true' />
                <span className='text-client-800 pr-10 font-semibold'>
                  {allServiceAddresses?.[0]?.full_address || 'No address provided'}
                </span>
              </div>
              <div className='flex '>
                <div className='w-6'></div>
                <div className='flex-1'>
                  <p className='text-sm text-gray-500' htmlFor='room-number'>
                    Room Number
                  </p>
                  <p className='text-client-800  font-semibold'>{allServiceAddresses?.[0]?.address_line_2 || '-'}</p>
                </div>
              </div>
            </div>
          ) : (
            <div className='mb-4'>
              {updateServiceAddressLoading ? (
                <Loader classes='h-72 w-full' text='Updating address...' />
              ) : (
                <div>
                  {groupData?.group_account_type == 'HOTEL' ? (
                    <div className='mb-1 flex'>
                      <MapPinIcon className='text-client-800 h-8 w-8' aria-hidden='true' />
                      <span className='text-client-800  font-semibold'>
                        {allServiceAddresses?.[0]?.full_address || 'No address provided'}
                      </span>
                    </div>
                  ) : (
                    <div className='mb-3'>
                      <form>
                        <div className='grid gap-5'>
                          <div>
                            <label className='go-label-16 mb-2 block' htmlFor='address_line_1'>
                              Address
                            </label>
                            <AddressAutofill
                              accessToken={MAPBOX_API_TOKEN}
                              options={{
                                language: 'en',
                                country: 'US',
                              }}
                              onRetrieve={addressChangeFn}
                            >
                              <input
                                ref={address1Field}
                                name='address_line_1'
                                className={`go-inputtext-16 ${
                                  isNull(addressData?.address_line_1) ? 'border-red-500' : ''
                                }`}
                                type='text'
                                placeholder='Address'
                                autoComplete='address-line1'
                                defaultValue={addressData?.address_line_1}
                              />
                            </AddressAutofill>
                          </div>
                          <div className='flex space-x-2'>
                            <div>
                              <label className='go-label-16 mb-2 block' htmlFor='address_line_2'>
                                Room Number
                              </label>
                              <input
                                ref={address2Field}
                                name='address_line_2'
                                className={`go-inputtext-16`}
                                type='text'
                                placeholder='Room Number'
                                autoComplete='address-line2'
                                defaultValue={addressData?.address_line_2}
                              />
                            </div>
                            <div>
                              <label className='go-label-16 mb-2 block' htmlFor='city'>
                                City
                              </label>
                              <input
                                ref={cityField}
                                name='city'
                                className={`go-inputtext-16 ${isNull(addressData?.city) ? 'border-red-500' : ''}`}
                                type='text'
                                placeholder='City'
                                autoComplete='address-level2'
                                defaultValue={addressData?.city}
                              />
                            </div>
                          </div>
                          <div className='flex space-x-2'>
                            <div>
                              <label className='go-label-16 mb-2 block' htmlFor='state'>
                                State
                              </label>
                              <input
                                ref={stateField}
                                name='state'
                                className={`go-inputtext-16 ${isNull(addressData?.state) ? 'border-red-500' : ''}`}
                                type='text'
                                placeholder='State'
                                autoComplete='address-level1'
                                defaultValue={addressData?.state}
                              />
                            </div>
                            <div>
                              <label className='go-label-16 mb-2 block' htmlFor='postal_code'>
                                Zip Code
                              </label>
                              <input
                                ref={zipField}
                                name='postal_code'
                                className={`go-inputtext-16 ${
                                  isNull(addressData?.postal_code) ? 'border-red-500' : ''
                                }`}
                                type='number'
                                placeholder='Postcode'
                                autoComplete='postal-code'
                                defaultValue={addressData?.postal_code}
                                maxLength={5}
                              />
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  )}
                  {groupData?.group_account_type == 'HOTEL' && (
                    <div className='flex '>
                      <div className='flex-1'>
                        <p className='go-label-16 mb-1' htmlFor='address_line_3'>
                          Room Number
                        </p>
                        <input
                          ref={address3Field}
                          id='address_line_3'
                          type='text'
                          className='go-inputtext-16'
                          placeholder=''
                          // onChange={(e) => setRoomNumber(e.target.value.replace(/[^a-zA-Z0-9]/g, '').slice(0, 10))}
                          onChange={(e) => setAddressData((prev) => ({ ...prev, address_line_2: e.target.value }))}
                          defaultValue={addressData?.address_line_2 || ''}
                          aria-label='Room Number'
                        />
                      </div>
                    </div>
                  )}
                  <div className='flex items-center justify-center space-x-4 py-5 '>
                    <ClientButton
                      variant='secondary'
                      text='Cancel'
                      size='xs'
                      onClick={(e) => {
                        e.preventDefault();
                        setEditAddress(false);
                      }}
                    />
                    <ClientButton
                      variant='primary'
                      text='Save'
                      size='xs'
                      onClick={() => {
                        onAddressSave();
                      }}
                    />
                  </div>
                </div>
              )}
            </div>
          )}

          <hr className='border-client-800 my-4 border-spacing-4 border-dashed' />
          {/* Pickup Date */}
          {pickupLoading ? (
            <Loader classes='h-72 w-full' text='Loading pickup times...' />
          ) : (
            <div>
              <div className='mb-2'>
                <div className='mb-2 flex items-center'>
                  <CalendarIcon className='text-client-800 h-6 w-6' aria-hidden='true' />
                  <span className='ml-2 font-medium text-gray-500'>Pickup Date</span>
                </div>
                <div className='flex-wrap2 mb-1 mt-2 flex flex-wrap gap-2'>
                  {(pickupDateBlocks
                    ? pickupDateBlocks.length > 3 && !showAllPickupDates
                      ? pickupDateBlocks.slice(0, 3)
                      : pickupDateBlocks
                    : []
                  ).map((d, key) => (
                    <button
                      key={key}
                      className={`mb-2 w-[30%] rounded-lg border px-4 py-2 transition-all ${
                        selectedTimeSlots?.pickup_date === d.dateUnformatted
                          ? 'border-blue-500 bg-blue-50 font-semibold text-blue-600'
                          : 'border-gray-200 bg-white font-semibold text-gray-900'
                      }`}
                      onClick={() => {
                        setSelectedTimeSlots((prevState) => ({
                          ...prevState,
                          pickup_date: d.dateUnformatted,
                          pickup_start_time: availablePickupSchedules?.[d.dateUnformatted]?.[0]?.start_time,
                          pickup_end_time: availablePickupSchedules?.[d.dateUnformatted]?.[0]?.end_time,
                          selected_pickup_time_id: timeIdGenarate(
                            d.dateUnformatted,
                            availablePickupSchedules?.[d.dateUnformatted]?.[0]?.start_time
                          ),
                        }));
                        onPickupDateChange(d.dateUnformatted);
                      }}
                      aria-label={`Pickup date ${d.dateWeekday} ${d.dateMonthDate}`}
                    >
                      {d.dateWeekday}
                      <br />
                      {d.dateMonthDate}
                    </button>
                  ))}
                </div>
                {pickupDateBlocks && pickupDateBlocks.length > 3 && (
                  <button className='mt-1 text-sm text-blue-500' onClick={() => setShowAllPickupDates((prev) => !prev)}>
                    {showAllPickupDates ? 'Show Less' : 'More Dates...'}
                  </button>
                )}
              </div>
              {/* Pickup Time */}
              <div className='mb-4 mt-4'>
                <div className='mb-2 flex items-center'>
                  <ClockIcon className='text-client-800 h-6 w-6' aria-hidden='true' />
                  <span className='ml-2 font-medium text-gray-500'>Pickup Time</span>
                </div>
                <div className='relative'>
                  {!isEmpty(pickupTimeBlocks) && (
                    <DropdownDateTime
                      dropdownValues={pickupTimeBlocks}
                      icon={<ClockIcon />}
                      onChange={(time) => {
                        setSelectedTimeSlots((prevState) => ({
                          ...prevState,
                          pickup_start_time: time?.default?.start_time,
                          pickup_end_time: time?.default?.end_time,
                          selected_pickup_time_id: time?.id,
                        }));
                      }}
                      placeholder='Pick a Time'
                      defaultValue={pickupTimeBlocks?.find(
                        (item) => item?.id === selectedTimeSlots?.selected_pickup_time_id
                      )}
                      type='time'
                    />
                  )}
                </div>
              </div>
            </div>
          )}
          <hr className='border-client-800 my-4 border-spacing-4 border-dashed' />
          {/* Delivery Date */}
          {deliveryLoading ? (
            <Loader classes='h-72 w-full' text='Loading dropoff times...' />
          ) : (
            <div>
              <div className='mb-2'>
                <div className='mb-2 flex items-center'>
                  <CalendarIcon className='text-client-800 h-6 w-6' aria-hidden='true' />
                  <span className='ml-2 font-medium text-gray-500'>Delivery Date</span>
                </div>
                <div className='flex-wrap2 mb-1 mt-2 flex flex-wrap gap-2'>
                  {(deliveryDateBlocks
                    ? deliveryDateBlocks.length > 3 && !showAllDropoffDates
                      ? deliveryDateBlocks.slice(0, 3)
                      : deliveryDateBlocks
                    : []
                  ).map((d, key) => (
                    <button
                      key={key}
                      className={`mb-2 w-[30%] rounded-lg border px-4 py-2 transition-all ${
                        selectedTimeSlots?.dropoff_date === d.dateYYYYMMDD
                          ? 'border-blue-500 bg-blue-50 font-semibold text-blue-600'
                          : 'border-gray-200 bg-white font-semibold text-gray-900'
                      }`}
                      onClick={() => {
                        setSelectedTimeSlots((prevState) => ({
                          ...prevState,
                          dropoff_date: d.dateYYYYMMDD,
                          dropoff_start_time: availableDeliverySchedules?.[d.dateYYYYMMDD]?.[0]?.start_time,
                          dropoff_end_time: availableDeliverySchedules?.[d.dateYYYYMMDD]?.[0]?.end_time,
                          selected_dropoff_time_id: timeIdGenarate(
                            d.dateYYYYMMDD,
                            availableDeliverySchedules?.[d.dateYYYYMMDD]?.[0]?.start_time
                          ),
                        }));
                        onDeliveryDateChange(d.dateYYYYMMDD);
                      }}
                      aria-label={`Delivery date ${d.dateWeekday} ${d.dateMonthDate}`}
                    >
                      {d.dateWeekday}
                      <br />
                      {d.dateMonthDate}
                    </button>
                  ))}
                </div>
                {deliveryDateBlocks && deliveryDateBlocks.length > 3 && (
                  <button
                    className='mt-1 text-sm text-blue-500'
                    onClick={() => setShowAllDropoffDates((prev) => !prev)}
                  >
                    {showAllDropoffDates ? 'Show Less' : 'More Dates...'}
                  </button>
                )}
              </div>
              {/* Delivery Time */}
              <div className='mt-4'>
                <div className='mb-2 flex items-center'>
                  <ClockIcon className='text-client-800 h-6 w-6' aria-hidden='true' />
                  <span className='ml-2 font-medium text-gray-500'>Delivery Time</span>
                </div>
                <div className='relative'>
                  {!isEmpty(deliveryTimeBlocks) && (
                    <DropdownDateTime
                      dropdownValues={deliveryTimeBlocks}
                      icon={<ClockIcon />}
                      onChange={(time) => {
                        setSelectedTimeSlots((prevState) => ({
                          ...prevState,
                          dropoff_start_time: time?.default?.start_time,
                          dropoff_end_time: time?.default?.end_time,
                          selected_dropoff_time_id: time?.id,
                          is_rush: time?.is_rush || false,
                        }));
                      }}
                      placeholder='Pick a Time'
                      defaultValue={deliveryTimeBlocks?.find(
                        (item) => item?.id === selectedTimeSlots?.selected_dropoff_time_id
                      )}
                      type='time'
                    />
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      {/* Services */}
      <div className='rounded-2xl bg-white p-6 shadow'>
        <h2 className='text-client-800 mb-4 text-base font-semibold'>Services</h2>
        <hr className='mb-4' />
        {/* <div className='space-y-3'>
          {services.map((service, idx) => (
            <div key={idx} className='flex items-center space-x-3 rounded-lg border bg-blue-50 px-4 py-3'>
              {service.icon}
              <div>
                <div className='text-client-800 font-semibold'>{service.name}</div>
                <div className='text-sm text-gray-600'>{service.price}</div>
              </div>
            </div>
          ))}
        </div> */}
        <GroupServices />
      </div>
      {/* Notes / Preferences */}
      <div className='rounded-2xl bg-white p-6 shadow'>
        <h2 className='text-client-800 mb-4 text-base font-semibold'>Notes / Preferences</h2>
        <hr className='mb-2' />
        {/* <span className='text-sm text-gray-600'>Order Notes and Preferences</span>
        <textarea
          rows={3}
          type='text'
          className='w-full rounded-md border border-gray-400 bg-gray-50 px-3 py-2 text-gray-700'
          value={notes}
          onChange={(e) => setPreferences(e.target.value)}
          aria-label='Order Notes and Preferences'
        /> */}
        <OrderPreferencesModule
          type={'edit'}
          preferences={preferences}
          update={(obj) => setPreferences(obj)}
          loader={false}
          isGroupOrder={true}
        />
      </div>
      {/* Tip */}
      <div className='rounded-2xl bg-white p-6 shadow'>
        <h2 className='text-client-800 mb-4 text-base font-semibold'>Tip For Your Service Provider</h2>
        <hr className='mb-2' />
        <input
          type='text'
          className={`w-40 rounded-md border border-gray-400 bg-gray-50 px-3 py-2 text-gray-700 ${
            !isTipValid && 'border-red-500'
          }`}
          placeholder='$0.00'
          value={tip}
          onChange={(e) => setTip(e.target.value.replace(/[^0-9.]/g, '').slice(0, 8))}
          aria-label='Tip'
        />
        {!isTipValid && <div className='mt-1 text-xs text-red-500'>Invalid tip amount</div>}
      </div>
      {/* Payment */}
      <div className='rounded-2xl bg-white p-6 shadow'>
        <h2 className='text-client-800 mb-4 text-base font-semibold'>Payment</h2>
        <hr className='mb-4' />
        {stripeLoading ? (
          <Loader text='Loading...' />
        ) : (
          <div>
            {editBillingDetails ? (
              <Stripe
                addressid={allServiceAddresses?.[0]?.id}
                cardAdded={() => getBillingDetailsFn(allServiceAddresses?.[0]?.id)}
                cancel={billingDetails ? () => setEditBillingDetails(false) : undefined}
              />
            ) : (
              <div className='flex items-center justify-between'>
                <p className='go-textblack-16 py-0.5'>
                  {titleCaseFormatter(
                    billingDetails?.addresses?.[0]?.billing_details?.default_payment_method?.card_brand
                  )}{' '}
                  **** **** **** {billingDetails?.addresses?.[0]?.billing_details?.default_payment_method?.card_last4}
                </p>
                <EditIcon
                  className='h-6 w-6 cursor-pointer text-gray-500 hover:text-gray-700'
                  onClick={() => {
                    setEditBillingDetails(true);
                  }}
                />
              </div>
            )}
          </div>
        )}
      </div>
      <div className='flex justify-center'>
        <button
          className='hover:bg-client-lcpink mt-2 flex w-full justify-center rounded-full bg-pink-400 py-3 text-lg font-semibold text-white transition disabled:opacity-50'
          type='button'
          onClick={() => createOrderFn()}
          disabled={
            loading ||
            !selectedTimeSlots?.pickup_date ||
            !selectedTimeSlots?.dropoff_date ||
            !selectedTimeSlots?.selected_pickup_time_id ||
            !selectedTimeSlots?.selected_dropoff_time_id ||
            selectedServices.length === 0 ||
            !isTipValid ||
            stripeLoading ||
            billingDetails?.addresses?.[0]?.billing_details?.default_payment_method_type != 'STRIPE'
          }
        >
          {loading ? (
            <svg className='h-6 w-6 animate-spin stroke-white' viewBox='0 0 256 256'>
              <line
                x1='128'
                y1='32'
                x2='128'
                y2='64'
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth='24'
              ></line>
              <line
                x1='195.9'
                y1='60.1'
                x2='173.3'
                y2='82.7'
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth='24'
              ></line>
              <line
                x1='224'
                y1='128'
                x2='192'
                y2='128'
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth='24'
              ></line>
              <line
                x1='195.9'
                y1='195.9'
                x2='173.3'
                y2='173.3'
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth='24'
              ></line>
              <line
                x1='128'
                y1='224'
                x2='128'
                y2='192'
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth='24'
              ></line>
              <line
                x1='60.1'
                y1='195.9'
                x2='82.7'
                y2='173.3'
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth='24'
              ></line>
              <line
                x1='32'
                y1='128'
                x2='64'
                y2='128'
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth='24'
              ></line>
              <line
                x1='60.1'
                y1='60.1'
                x2='82.7'
                y2='82.7'
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth='24'
              ></line>
            </svg>
          ) : (
            'Create Order'
          )}
        </button>
      </div>
      <GroupFormSummary modalOpen={modalOpen} setModalOpen={setModalOpen} isRush={selectedTimeSlots?.is_rush} />
    </div>
  );
}
